import React from 'react';
import ContactUsForm from '../shared/ContactUsForm/ContactUsForm';

const Contact = () => {
  return <ContactUsForm showHeader={true} />;
};

export default Contact;

